// alterado - revisado

const calculaConjugeProfissaoConjugeOutras = ( values ) => {
    if (values.profissaoConjuge !== "Outras") {
        values.profissaoConjugeOutras = ''
    }
}

export const processaAlteracaoConjugeProfissaoConjuge = ( values ) => {
    calculaConjugeProfissaoConjugeOutras(values)
}
